import React from 'react';
import {Box} from '@tempo/core';

import BackgroundTablet from '@deezer/next/assets/img/landing/DfC-Tablet.png';
import BackgroundDesktop from '@deezer/next/assets/img/landing/DfC-Desktop.png';

type LandingBackgroundProps = {
	children: React.ReactNode;
};

const LandingBackground = ({children}: LandingBackgroundProps) => {
	return (
		<Box
			backgroundImage={{
				base: `url(${BackgroundTablet.src})`,
				md: `url(${BackgroundDesktop.src})`,
			}}
			backgroundRepeat="no-repeat"
			backgroundColor="background.neutral.primary.default"
			backgroundPosition={{base: 'center', md: 'right'}}
			backgroundSize="contain"
			height={{base: '85vh', sm: '100vh'}}
			sx={{
				'@media screen and (max-aspect-ratio:1.2)': {
					backgroundImage: `url(${BackgroundTablet.src})`,
					backgroundPosition: 'center',
				},
			}}
		>
			{children}
		</Box>
	);
};

export default LandingBackground;
